<mat-menu #filterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller">

    <!-- <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field>
        <mat-select placeholder="{{ 'home.filter.criterion' | transloco }}" [(value)]="searchCriterion[caller]">
          <mat-option *ngFor="let criterion of criteriaList" [value]="criterion.value">
            {{ 'home.filter.criteriaList.' + criterion.value | transloco }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->

    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field>
        <input matInput placeholder="{{ 'home.filter.value' | transloco }}" [(ngModel)]="searchValue[caller]"
          autocomplete="off">
      </mat-form-field>
    </div>

    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="clearColumn(caller)"
        type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="applyColumnFilter(caller)"
        type="button">{{ 'home.filter.startFilter' | transloco }}</button>
    </div>

  </ng-template>
</mat-menu>




<mat-menu #dateFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller">

    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field class="filter-input">
        <mat-select placeholder="{{ 'home.filter.criterion' | transloco }}" [(value)]="searchCriterion[caller]">
          <mat-option *ngFor="let criterion of dateCriteriaList" [value]="criterion.value">
            {{ 'home.filter.criteriaList.' + criterion.value | transloco }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field class="filter-input">
        <mat-label>YYYY-MM-DD</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="searchValue[caller]" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="clearColumn(caller)"
        type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="applyDateColumnFilter()"
        type="button">{{ 'home.filter.startFilter' | transloco }}</button>
    </div>

  </ng-template>
</mat-menu>




<mat-menu #checkboxFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-categories="categories">

    <div *ngFor="let category of categories" mat-menu-item mat-filter-item [disableRipple]="true"
      (click)="$event.stopPropagation()">
      <mat-checkbox [checked]="isSelected(category, selectedCategories[caller])"
        (change)="setSelected($event.checked, category, selectedCategories, caller)">
        {{ category.name }}
      </mat-checkbox>
    </div>

    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="clearColumn(caller)"
        type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="applyCheckboxColumnFilter(caller, selectedCategories[caller])"
        type="button">{{ 'home.filter.startFilter' | transloco }}</button>
    </div>

  </ng-template>
</mat-menu>




<mat-menu #tagFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-possibleTags="possibleTags">

    <div class="tag-filter-list">
      <div *ngFor="let tag of possibleTags" mat-menu-item mat-filter-item [disableRipple]="true"
        (click)="$event.stopPropagation()">
        <mat-checkbox [checked]="isSelected(tag, selectedTags[caller])"
          (change)="setSelected($event.checked, tag, selectedTags, caller)">
          {{ tag.name }}
        </mat-checkbox>
      </div>
    </div>
    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="clearColumn(caller)" type="button">{{ 'home.filter.removeFilter' | transloco
        }}</button>
      <button mat-raised-button color="primary" (click)="applyTagColumnFilter(caller, selectedTags[caller])"
        type="button">{{ 'home.filter.startFilter' | transloco }}</button>
    </div>

  </ng-template>
</mat-menu>




<mat-menu #multiSelectFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-categories="categories" let-translation="translation">
    <div class="multiSelect-filter" mat-menu-item [disableRipple]="false" (click)="preventEventBubbling($event)">
      <app-multi-select-with-search label="{{ 'home.filter.multiText.' + translation }}" [multiple]="true"
        [itemsToSelect]="categories" [selectAllValue]="selectAllValue" (valueChanges)="multiSelectValueChanged($event, caller)"
        [formControl]="getFormControl(caller)" [panelWidth]="(multiSelectFilterWidth - 32).toString() + 'px'">
      </app-multi-select-with-search>
    </div>
    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="clearColumn(caller)" type="button">{{ 'home.filter.removeFilter' | transloco
        }}</button>
      <button mat-raised-button color="primary" (click)="applyMultiSelectColumnFilter(caller)" type="button">{{
        'home.filter.startFilter' | transloco }}</button>
    </div>
  </ng-template>
</mat-menu>
